/* Afroyla FALL CLEARANCE — shelf: browse-first grid. Feed: /collections/fall-clearance/products.json filtered
 * client-side by tag fc-type-<type>. 5 price-ladder group chips + All (cheapest group first), counts + "from $"
 * computed live from the feed (never hardcoded). First card per group = pinned "Best discount · N% off" (real
 * max). Card price = the Premium Vegan variant (not necessarily the cheapest option on the product). 24/page +
 * "Show 24 more". Multi-variant → in-card picker, Vegan first + preselected. Tap image → quick view sheet.
 * Feed may be empty/partial while ops finishes publishing — degrades to a friendly message, never throws.
 * Lightning-zone products (handles in the rotation.json the Lightning box reads, root[data-rotation]) are hidden
 * from the shelf (anh 10-13, ops 2-zone split: Lightning = 60% only in the rotating box, Deal = 50–55% on the shelf)
 * so a 60% item is never sitting in the grid next to its 30 s Lightning slot. Rotation fetch fails → no exclusion.
 * Only runs while the page phase is 'live'. Needs window.AFC. */
(function () {
  var A = window.AFC;
  if (!A) return;
  var root = A.root;
  var grid = root.querySelector('[data-afc-grid]');
  if (!grid) return;
  var chipsEl = root.querySelector('[data-afc-chips]');
  var shelfEl = root.querySelector('#afc-shelf');
  var PAGE = 24;
  // [key, label, fc-type-* suffixes] — cheapest group first, ≤6 chips total (paradox-of-choice ruling)
  var CHIPS = [
    ['all', 'All deals', null],
    ['wallets', 'Wallets & Makeup', ['wallet', 'mini-wallet', 'makeup-bag']],
    ['crossbodies', 'Crossbodies', ['circle-crossbody', 'envelope-crossbody', 'mini-satchel']],
    ['totes', 'Totes & Small Handbags', ['tote', 'small-handbag']],
    ['handbags', 'Handbags & Backpacks', ['handbag', 'forelio-handbag', 'backpack']],
    ['sets', 'Bag + Wallet Sets', ['set-bag-wallet']]
  ];
  var items = [], byId = {}, cur = { chip: 'all', shown: PAGE }, started = false;

  function loadFeed(page, acc) {
    return fetch('/collections/fall-clearance/products.json?limit=250&page=' + page, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) {
        acc.push.apply(acc, j.products || []);
        return (j.products || []).length === 250 && page < 3 ? loadFeed(page + 1, acc) : acc;
      });
  }

  function veganVariant(vars) {
    var vegan = vars.filter(function (v) { return /vegan|faux/i.test(v.name); });
    if (vegan.length) return vegan[0];
    var avail = vars.filter(function (v) { return v.available; });
    return (avail.length ? avail : vars).reduce(function (m, v) { return v.price < m.price ? v : m; });
  }

  function toItem(p) {
    var vars = p.variants.map(function (v) { return { id: v.id, name: v.title, price: +v.price, compare: +(v.compare_at_price || 0), available: v.available }; });
    var typeTag = p.tags.filter(function (t) { return t.indexOf('fc-type-') === 0; })[0] || '';
    return { id: p.id, h: p.handle, t: A.cleanTitle(p.title), img: p.images && p.images[0] ? p.images[0].src : '',
      type: typeTag.replace('fc-type-', ''), vars: vars, vegan: veganVariant(vars), avail: vars.some(function (v) { return v.available; }) };
  }

  function chipOf(key) { return CHIPS.filter(function (c) { return c[0] === key; })[0] || CHIPS[0]; }
  function inChip(c) { return c[2] ? items.filter(function (it) { return c[2].indexOf(it.type) > -1; }) : items; }
  var best = {};
  function list() {
    var l = inChip(chipOf(cur.chip));
    best = {};
    var avail = l.filter(function (it) { return it.avail && it.vegan.compare > it.vegan.price; });
    if (!avail.length) return l;
    var pctOf = function (it) { return A.pct(it.vegan.price, it.vegan.compare); };
    var d = avail.reduce(function (m, it) { return pctOf(it) > pctOf(m) ? it : m; });
    best[d.id] = 'Best discount · ' + pctOf(d) + '% off';
    return [d].concat(l.filter(function (it) { return it.id !== d.id; }));
  }
  function priceHint(l) {
    var mins = l.map(function (it) { return it.vegan.price; });
    return Math.max.apply(null, mins) < 15 ? 'under $15' : 'from ' + A.money(Math.min.apply(null, mins));
  }

  function cardHtml(it) {
    var v = it.vegan;
    var off = A.pct(v.price, v.compare);
    var url = '/products/' + it.h;
    var label = !it.avail ? 'Sold out' : it.vars.length > 1 ? 'Claim deal' : 'Claim · ' + A.money(v.price);
    return '<article class="afc-card' + (it.avail ? '' : ' is-soldout') + (best[it.id] ? ' is-best' : '') + '" data-card="' + it.id + '">' +
      '<a class="afc-card__media" href="' + url + '" data-afc-quick="' + A.esc(it.h) + '" data-hc-el="card-quick-view">' +
        '<img src="' + A.img(it.img, 540) + '" alt="' + A.esc(it.t) + '" loading="lazy" width="540" height="720">' +
        (off ? '<span class="afc-badge">−' + off + '%</span>' : '') + (it.avail ? '' : '<span class="afc-soldout">Sold out</span>') +
        (best[it.id] ? '<span class="afc-best">' + A.esc(best[it.id]) + '</span>' : '') + '</a>' +
      '<div class="afc-card__body">' +
        '<a class="afc-card__title" href="' + url + '" data-hc-el="card-title">' + A.esc(it.t) + '</a>' +
        '<p class="afc-price"><span class="afc-price__now">' + A.money(v.price) + '</span>' +
          (v.compare > v.price ? ' <s class="afc-price__was">' + A.money(v.compare) + '</s>' : '') + (off ? ' <span class="afc-price__off">−' + off + '%</span>' : '') + '</p>' +
        '<div class="afc-card__act" data-act="' + it.id + '"><button type="button" class="afc-btn" data-add-card="' + it.id + '"' + (it.avail ? '' : ' disabled') + ' data-hc-el="card-claim">' + label + '</button></div>' +
      '</div></article>';
  }

  function pickerHtml(it) {
    var ordered = A.orderVariants(it.vars);
    var labels = A.variantLabels(ordered.map(function (x) { return x.name; }), true);
    return '<p class="afc-pick__k">Choose one <button type="button" class="afc-pick__x" data-pick-close="' + it.id + '" aria-label="Cancel">×</button></p>' +
      '<div class="afc-pick">' + ordered.map(function (x, k) {
        return '<button type="button" class="afc-var" data-pick="' + x.id + '" data-pid="' + it.id + '"' + (x.available ? '' : ' disabled') + ' data-hc-el="card-variant-picker">Add ' + A.esc(labels[k]) + ' <b>' + A.money(x.price) + '</b></button>';
      }).join('') + '</div>';
  }
  function closePicker(id) { var el = grid.querySelector('[data-card="' + id + '"]'); if (el) el.outerHTML = cardHtml(byId[id]); }

  function renderChips() {
    chipsEl.innerHTML = CHIPS.map(function (c) {
      var l = inChip(c);
      if (!l.length) return '';
      return '<button type="button" class="afc-chip' + (c[0] === cur.chip ? ' is-on' : '') + '" aria-pressed="' + (c[0] === cur.chip) + '" data-chip="' + c[0] + '" data-hc-el="chip">' +
        A.esc(c[1]) + ' <span>' + (c[2] ? priceHint(l) + ' · ' : '') + l.length + '</span></button>';
    }).join('');
  }

  function renderGrid() {
    var l = list();
    var html = l.slice(0, cur.shown).map(cardHtml).join('') || '<p class="afc-grid__msg">Nothing left here. Try another type.</p>';
    if (l.length > cur.shown) html += '<div class="afc-more"><button type="button" class="afc-btn afc-btn--ghost" data-more data-hc-el="show-more">Show ' +
      Math.min(PAGE, l.length - cur.shown) + ' more (' + (l.length - cur.shown) + ' left)</button></div>';
    grid.innerHTML = html;
  }

  function select(chip, fromHash) {
    if (!CHIPS.some(function (c) { return c[0] === chip; })) chip = 'all';
    cur.chip = chip; cur.shown = PAGE;
    renderChips(); renderGrid();
    if (!fromHash) { try { history.replaceState(null, '', chip === 'all' ? location.pathname + location.search + '#afc-shelf' : '#type-' + chip); } catch (e) { /* ignore */ } }
  }

  chipsEl.addEventListener('click', function (e) { var c = e.target.closest('[data-chip]'); if (c) select(c.dataset.chip); });
  grid.addEventListener('click', function (e) {
    var pick = e.target.closest('[data-pick]');
    if (pick) { var pid = pick.dataset.pid; A.runAdd(pick, Number(pick.dataset.pick), A.img(byId[pid].img, 300)).then(function () { closePicker(pid); }); return; }
    var close = e.target.closest('[data-pick-close]');
    if (close) { closePicker(close.dataset.pickClose); return; }
    var add = e.target.closest('[data-add-card]');
    if (add) {
      var it = byId[add.dataset.addCard];
      if (it.vars.length > 1) { grid.querySelector('[data-act="' + it.id + '"]').innerHTML = pickerHtml(it); return; }
      A.runAdd(add, it.vegan.id, A.img(it.img, 300));
      return;
    }
    if (e.target.closest('[data-more]')) { cur.shown += PAGE; renderGrid(); }
  });

  function hashChip() {
    var m = /^#type-([a-z-]+)$/.exec(location.hash);
    if (!m) return null;
    var hit = CHIPS.filter(function (c) { return c[0] === m[1] || (c[2] && c[2].indexOf(m[1]) > -1); })[0];
    return hit ? hit[0] : null;
  }
  window.addEventListener('hashchange', function () { var c = hashChip(); if (c) { select(c, true); shelfEl.scrollIntoView({ block: 'start' }); } });

  // handle → true for every Lightning-zone product; resolves {} on any error so the shelf still renders
  function loadLightningHandles() {
    if (!root.dataset.rotation) return Promise.resolve({});
    return fetch(root.dataset.rotation, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : []; })
      .then(function (list) { var m = {}; (list || []).forEach(function (it) { if (it && it.handle) m[it.handle] = true; }); return m; })
      .catch(function () { return {}; });
  }

  function start() {
    if (started) return;
    started = true;
    Promise.all([loadFeed(1, []), loadLightningHandles()])
      .then(function (r) {
        var lightning = r[1];
        items = r[0].filter(function (p) { return !lightning[p.handle]; }).map(toItem).filter(function (it) { return it.type; });
        items.sort(function (a, b) { return (b.avail ? 1 : 0) - (a.avail ? 1 : 0); });
        items.forEach(function (it) { byId[it.id] = it; });
        var c = hashChip();
        select(c || 'all', true);
        if (c) shelfEl.scrollIntoView({ block: 'start' });
      })
      .catch(function () { grid.innerHTML = '<p class="afc-grid__msg">Deals are loading slowly. Please refresh the page.</p>'; });
  }
  root.addEventListener('afc:phase', function (e) { if (e.detail.phase === 'live') start(); });
  if (A.phase && A.phase() === 'live') start();
})();
